enum SegmentKind {
  SEGMENT_KIND_BOOLEAN = 16,
  SEGMENT_KIND_TEXT = 32,
  SEGMENT_KIND_UNKNOWN = 48
}

export { SegmentKind };
